import React from 'react'

export default function ClutchIcon() {
   return (
      <svg
         width="49"
         height="49"
         viewBox="0 0 49 49"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <circle cx="24.2773" cy="24.5503" r="24" fill="#F1ECDC" />
         <path
            d="M25.5177 20.79C26.5149 20.79 27.4713 21.1862 28.1764 21.8913C28.8815 22.5964 29.2777 23.5528 29.2777 24.55C29.2777 25.5472 28.8815 26.5035 28.1764 27.2086C27.4713 27.9138 26.5149 28.3099 25.5177 28.3099C24.5205 28.3099 23.5642 27.9138 22.8591 27.2086C22.1539 26.5035 21.7578 25.5472 21.7578 24.55C21.7578 23.5528 22.1539 22.5964 22.8591 21.8913C23.5642 21.1862 24.5205 20.79 25.5177 20.79Z"
            fill="#1F473E"
         />
         <path
            d="M33.3651 32.2091C31.3876 34.2438 28.7016 35.3463 25.8751 35.3463C20.0818 35.3463 15.8695 30.7959 15.8695 24.5502C15.8695 18.2758 20.0818 13.7254 25.8751 13.7254C28.6743 13.7254 31.3304 14.8266 33.3378 16.834L34.1283 17.6258L37.6048 14.1493L36.8416 13.3575C33.9593 10.3893 30.0589 8.77979 25.8751 8.77979C17.3399 8.77979 10.9238 15.5625 10.9238 24.5775C10.9238 33.5652 17.3685 40.3206 25.8751 40.3206C30.0875 40.3206 33.9879 38.6824 36.8702 35.7143L37.6334 34.9225L34.1855 31.3901L33.3651 32.2091Z"
            fill="#1F473E"
         />
      </svg>
   )
}
